import { validAFM, validSumPercentage } from 'utils';
// import { countriesList } from '../countriesList';
import { validateAFM } from 'utils/utilsLoans';

export const beneficialOwnersFields = (
  withBin = false,
  beneficialOwners,
  index
) => [
  {
    label: 'Ονοματεπώνυμο',
    type: 'text',
    name: 'fullName',
    id: 'fullName',
    size: 'large',
    placeholder: 'Εισάγετε Ονοματεπώνυμο',
    asterisk: true,
    // span: withBin ? 5 : 6,
    span: 6,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      {
        validator(_, value) {
          const duplicateCount = beneficialOwners.filter(
            u => u.fullName === value
          ).length;

          if (duplicateCount > 1) {
            return Promise.reject(
              'Το Ονοματεπώνυμο πρέπει να είναι μοναδικό ανά Πραγματικό Δικαιούχο'
            );
          }
        },
      },
    ],
  },
  {
    label: 'Α.Φ.Μ.',
    type: 'text',
    name: 'taxId',
    id: 'taxId',
    size: 'large',
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    maxLength: 15,
    asterisk: true,
    span: 3,
    // containerClassName: "name-width",
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          const duplicateCount = beneficialOwners.filter(
            u => u.taxId === value
          ).length;

          if (duplicateCount > 1) {
            return Promise.reject(
              'Το Α.Φ.Μ. πρέπει να είναι μοναδικό ανά Πραγματικό Δικαιούχο'
            );
          }
          return validateAFM(value);
        },
      }),
    ],
  },
  {
    label: 'Ημ. Γέννησης',
    type: 'date',
    name: 'birthDate',
    className: 'multiple-lines-field-select',
    id: 'birthDate',
    size: 'large',
    span: 4,
    asterisk: true,
  },
  {
    label: '% Συμμετοχής',
    type: 'numberWithDecimals',
    name: 'participationPercentage',
    id: 'participationPercentage',
    suffix: '%',
    size: 'large',
    placeholder: 'Εισάγετε % Συμμετοχής',
    maxLength: 12,
    decimalsLimit: 15,
    span: 5,
    className: 'shareHolderPercentage',
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      {
        validator: (_, value) => {
          const currentValue = parseFloat(value.replaceAll(',', '.')) || 0;

          const total = beneficialOwners.reduce((sum, item, i) => {
            if (i === index) return sum + currentValue;
            const perc = parseFloat(item.participationPercentage) || 0;
            return sum + perc;
          }, 0);

          if (total > 100) {
            return Promise.reject(
              'Το Ποσοστό Συμμετοχής δεν μπορεί να ξεπερνάει το 100%'
            );
          }

          return validSumPercentage(currentValue);
        },
      },
    ],
  },
  {
    label: 'Ιδιότητα',
    type: 'text',
    name: 'role',
    id: 'role',
    size: 'large',
    placeholder: 'Εισάγετε Ιδιότητα',
    asterisk: true,
    span: withBin ? 5 : 6,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
];
